module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pusher"
  }, [_c('div', {
    staticClass: "ui inverted vertical center aligned segment"
  }, [_c('div', {
    staticClass: "ui container"
  }, [_c('div', {
    staticClass: "ui large secondary inverted pointing menu"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "right item"
  }, [_c('a', {
    staticClass: "ui inverted button",
    on: {
      "~click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("Log Out")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui container basic segment"
  }, [_c('div', {
    staticClass: "ui tab active",
    attrs: {
      "data-tab": "data"
    }
  }, [_c('h4', {
    staticClass: "ui header"
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n            Download\n            "), _c('div', {
    staticClass: "ui inline dropdown"
  }, [_c('div', {
    staticClass: "text",
    model: {
      value: (_vm.dataQuery_dateRange),
      callback: function($$v) {
        _vm.dataQuery_dateRange = $$v
      },
      expression: "dataQuery_dateRange"
    }
  }, [_vm._v(_vm._s(_vm.dataQuery_dateRange))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Adjust time span")]), _vm._v(" "), _c('div', {
    staticClass: "active item",
    attrs: {
      "data-text": "latest"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '1'
      }
    }
  }, [_vm._v("Latest")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "1 month"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '4'
      }
    }
  }, [_vm._v("1 month")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "3 months"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '12'
      }
    }
  }, [_vm._v("3 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "6 months"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '26'
      }
    }
  }, [_vm._v("6 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "12 months"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '52'
      }
    }
  }, [_vm._v("12 months")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "all"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dateRange = '999'
      }
    }
  }, [_vm._v("all")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui inline dropdown"
  }, [_c('div', {
    staticClass: "text",
    model: {
      value: (_vm.dataQuery_dataType),
      callback: function($$v) {
        _vm.dataQuery_dataType = $$v
      },
      expression: "dataQuery_dataType"
    }
  }, [_vm._v(_vm._s(_vm.dataQuery_dataType))]), _vm._v(" "), _c('i', {
    staticClass: "dropdown icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Change the data type")]), _vm._v(" "), _c('div', {
    staticClass: "active item",
    attrs: {
      "data-text": "listings"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dataType = 'listings'
      }
    }
  }, [_vm._v("listings")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "rentals"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dataType = 'rentals'
      }
    }
  }, [_vm._v("rentals")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    attrs: {
      "data-text": "stats"
    },
    on: {
      "click": function($event) {
        _vm.dataQuery_dataType = 'stats'
      }
    }
  }, [_vm._v("stats")])])]), _vm._v("\n\n             data for\n\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataQuery_counties),
      expression: "dataQuery_counties"
    }],
    staticClass: "ui search dropdown inline",
    class: {
      'hidden': _vm.canSelectCounty
    },
    attrs: {
      "id": "filterCounties",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.dataQuery_counties = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Location")]), _vm._v(" "), _vm._l((_vm.counties), function(c) {
    return _c('option', {
      domProps: {
        "value": c
      },
      on: {
        "click": function($event) {
          _vm.addCounty(c)
        }
      }
    }, [_vm._v(_vm._s(c))])
  })], 2), _vm._v(" "), _c('small', {
    class: {
      'hidden': !_vm.canSelectCounty || _vm.counties.length < 5
    },
    on: {
      "click": function($event) {
        _vm.allCounties()
      }
    }
  }, [_vm._v("(all)")]), _vm._v(" "), _c('span', {
    class: {
      'hidden': _vm.canSelectCounty
    },
    attrs: {
      "id": "entire-us"
    }
  }, [_vm._v("US")]), _vm._v(" "), _c('div', {
    staticClass: "ui button primary",
    on: {
      "click": function($event) {
        _vm.getList()
      }
    }
  }, [_vm._v("GO")])])]), _vm._v(" "), _c('div', {
    staticClass: "ui hidden divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui styled fluid accordion"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "active content"
  }, [_c('div', {
    staticClass: "ui bottom attached segment"
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(3), _vm._v(" "), _vm._l((_vm.list), function(c) {
    return _c('tr', [_c('td', {
      staticClass: "collapsing"
    }, [_vm._v(_vm._s(c.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(c.county) + " - " + _vm._s(c.state) + " - " + _vm._s(c.type))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('form', {
      attrs: {
        "method": "get",
        "action": _vm.baseDataUrl
      }
    }, [_c('input', {
      attrs: {
        "type": "hidden",
        "name": "county"
      },
      domProps: {
        "value": c.state_county
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "date"
      },
      domProps: {
        "value": c.date
      }
    }), _vm._v(" "), _c('input', {
      attrs: {
        "type": "hidden",
        "name": "type"
      },
      domProps: {
        "value": c.type
      }
    }), _vm._v(" "), _vm._m(4, true)])])])
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.list.length > 0) ? _c('button', {
    staticClass: "ui secondary button",
    on: {
      "click": function($event) {
        _vm.downloadAll()
      }
    }
  }, [_vm._v("\n                Download all\n              ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "ui tab",
    attrs: {
      "data-tab": "activity"
    }
  }, [_vm._v("\n        Last activity, downloads and logins etc.\n        "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.activity), function(a) {
    return _c('tr', [_c('td', {
      staticClass: "collapsing"
    }, [_vm._v(_vm._s(a.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(a.description))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_vm._v(_vm._s(a.who))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "ui tab",
    attrs: {
      "data-tab": "settings"
    }
  }, [_c('div', {
    staticClass: "ui cards"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n                " + _vm._s(_vm.user.email) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui small feed"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._v("\n                    " + _vm._s(_vm.user.phone) + "\n                  ")])]), _vm._v(" "), _vm._m(6)])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Subscription:")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('i', {
    staticClass: "flag us"
  }), _vm._v("\n\n                " + _vm._s(_vm.user.plan) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui small feed"
  }, [_c('div', {
    staticClass: "content"
  }, [(!_vm.countyPlan) ? _c('div', [_vm._v("3000 counties across the US")]) : _vm._e()])])]), _vm._v(" "), (_vm.countyPlan) ? _c('h4', {
    staticClass: "ui sub header"
  }, [_vm._v("Counties")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.counties), function(c) {
    return (_vm.countyPlan) ? _c('div', {
      staticClass: "ui small feed"
    }, [_c('div', {
      staticClass: "county"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "summary"
    }, [_vm._v("\n                       " + _vm._s(c) + "\n                    ")])])])]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.countyPlan) ? _c('div', {
    staticClass: "ui bottom attached button"
  }, [_c('i', {
    staticClass: "add icon"
  }), _vm._v("\n              Add County\n            ")]) : _vm._e()])]), _vm._v(" "), (_vm.bills.length > 0) ? _c('h2', [_vm._v("Billing History")]) : _vm._e(), _vm._v(" "), (_vm.bills.length > 0) ? _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(8), _vm._v(" "), _vm._l((_vm.bills), function(b) {
    return _c('tr', {
      class: {
        'positive': b.paid, 'negative': !b.paid
      }
    }, [_c('td', [_vm._v(_vm._s(b.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(b.amount))]), _vm._v(" "), _c('td', {
      staticClass: "collapsing"
    }, [_c('i', {
      staticClass: "icon",
      class: {
        'checkmark': b.paid, 'close': !b.paid
      }
    })]), _vm._v(" "), _vm._m(9, true)])
  })], 2) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(10)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "toc item"
  }, [_c('i', {
    staticClass: "sidebar icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui inverted secondary pointing menu tabs"
  }, [_c('a', {
    staticClass: "item active",
    attrs: {
      "data-tab": "data"
    }
  }, [_vm._v("\n              Data\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "activity"
    }
  }, [_vm._v("\n              Activity\n            ")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "data-tab": "settings"
    }
  }, [_vm._v("\n              Settings\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "active title"
  }, [_c('i', {
    staticClass: "dropdown icon"
  }), _vm._v("\n            via browser\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Download")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui button"
  }, [_c('i', {
    staticClass: "download icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Who")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "ui basic mini button"
  }, [_c('i', {
    staticClass: "lock icon"
  }), _vm._v("\n                  Change Password\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Credit Card")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("(Stored in Stripe)")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_c('div', {
    staticClass: "ui small feed"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "credit-card"
  }, [_vm._v("\n                      --\n                    ")])])]), _vm._v(" "), _c('button', {
    staticClass: "ui basic mini button"
  }, [_c('i', {
    staticClass: "credit card alternative icon"
  }), _vm._v("\n                  Update Card\n                ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Paid")]), _vm._v(" "), _c('th', {
    staticClass: "collapsing"
  }, [_vm._v("Invoice")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "collapsing"
  }, [_c('button', {
    staticClass: "ui button primary"
  }, [_c('i', {
    staticClass: "file text outline icon"
  }), _vm._v("\n                Invoice\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("\n          Contact us: "), _c('a', {
    attrs: {
      "href": "mailto:support@altosresearch.com"
    }
  }, [_vm._v("support@altosresearch.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1aad108","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 102
// module chunks = 1